export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Misión", "Misiones"]),
      aiProposal: "Propuesta IA",
      activitiesLinked: ({ named }) => `${named("count")} actividad(es) vinculada(s)`,
      levelOfAchievement: "Nivel de realización",
      validate: "Validar esta misión",
      decline: "Rechazar",
      merge: "Fusionar en...",
      defined: "Misiones definidas",
      no_missions: "No hay misiones definidas en este contrato.",
      import: "Importar la ficha de misión",
      import_from_sheet: "Empezar a añadir a partir de una ficha de misión",
      empty_no_sheet:
        "No hay misiones definidas. Importe una ficha de misión para empezar el seguimiento del aprendiz.",
      empty_no_sheet_no_ia: "No hay misiones definidas.",
      empty_no_sheet_cta: "Importar una ficha de misión",
      empty_has_sheet:
        "Se ha importado una ficha de misión. Inicie la extracción para convertir su contenido en misiones a seguir.",
      empty_has_sheet_cta: "Iniciar la extracción",
      no_ia_alert: "Defina y siga las misiones de su alumno en prácticas/aprendiz en esta pestaña",
      no_ia_alert_description: "Añadir una misión para su alumno en prácticas/aprendiz",
    },
    rncpGlobalAnalysis: {
      button: "Análisis global",
      confirm_title: "¿Iniciar el análisis global?",
      confirm_text:
        "Este análisis ofrece una visión de conjunto de la correlación entre las misiones y el referencial de competencias previsto, para situar la progresión global del alumno en alternancia.",
      launch: "Iniciar el análisis",
      loading_title: "Cálculo de la correlación global con el referencial",
      error_title: "No se ha podido completar el análisis",
      failed: "El análisis global ha fallado. Vuelva a iniciarlo.",
      retry: "Volver a iniciar el análisis",
      completed: "Análisis finalizado",
      step_reading_title: "Lectura de las misiones",
      step_reading_subtitle: "Conjunto de las misiones publicadas del contrato y vínculos ya validados",
      step_matching_title: "Cálculo de la correlación global",
      step_matching_subtitle: "Puntuación global y cobertura por bloque de competencias",
      result_title: "Resultado del análisis global",
      last_analysis: "Último análisis: {date}",
      missions_analysed: ({ plural, named }) =>
        plural([`${named("count")} misión analizada`, `${named("count")} misiones analizadas`]),
      score_label: "Puntuación de correlación global",
      coverage_title: "Cobertura por bloque de competencias",
      block_coverage_label: "{name}: {score} % de cobertura",
      result_empty: "Todavía no hay resultado del análisis global.",
      rncp_title_unknown: "Referencial no indicado",
    },
    rncpMissionAnalysis: {
      button: "Análisis por misión",
      confirm_title: "¿Iniciar el análisis por misión?",
      confirm_text:
        "Este análisis facilita la comprensión y la cartografía de las competencias desarrolladas por el aprendiz en el marco de sus misiones: propone correspondencias con el referencial, misión tras misión, que usted valida a su ritmo.",
      launch: "Iniciar el análisis",
      completed: "Análisis completado",
      loading_title: "Comparación de las misiones con el referencial de competencias",
      step_reading_title: "Lectura de las misiones",
      step_reading_subtitle: "Comentarios, niveles de realización, objetivos (historial de cuestionarios)",
      step_matching_title: "Comparación con el referencial",
      step_matching_subtitle: "Correspondencia con los bloques de competencias",
      failed: "El análisis por misión ha fallado. Vuelva a iniciarlo.",
      error_title: "No se ha podido completar el análisis",
      retry: "Volver a iniciar el análisis",
      result_title: "Resultado del análisis por misión",
      result_intro:
        "El análisis de la relación entre misiones y competencias facilita la comprensión y el mapeo de las competencias que el aprendiz desarrolla en el marco de sus misiones.",
      result_count: ({ plural, named }) => plural([`${named("count")} misión`, `${named("count")} misiones`]),
      result_empty: "No hay misiones que mostrar para este análisis.",
      mission_status_to_validate: "Por validar",
      mission_status_analysed: "Analizada",
      mission_status_none: "No analizada",
      mission_no_content: "Ninguna competencia validada ni sugerencia pendiente para esta misión.",
      validated_title: "Competencias validadas",
      pending_title: "Sugerencias de IA pendientes",
      validate: "Validar",
      refuse: "Rechazar",
      validate_label: ({ named }) => `Validar el bloque ${named("name")}`,
      refuse_label: ({ named }) => `Rechazar el bloque ${named("name")}`,
      remove_label: ({ named }) => `Quitar ${named("name")}`,
      score_value: ({ named }) => `Puntuación de relevancia: ${named("score")} %`,
      show_detail: "Ver el detalle",
      hide_detail: "Ocultar el detalle",
      show_detail_label: ({ named }) => `Ver el detalle del bloque ${named("name")}`,
      hide_detail_label: ({ named }) => `Ocultar el detalle del bloque ${named("name")}`,
      detail_skills: "Competencias del bloque",
      suggestion_validated: ({ named }) => `Bloque ${named("name")} validado para la misión ${named("mission")}`,
      suggestion_refused: ({ named }) => `Sugerencia ${named("name")} rechazada para la misión ${named("mission")}`,
      category_removed: ({ named }) => `Bloque ${named("name")} quitado de la misión ${named("mission")}`,
      mission_skills_title: "Bloque de competencia vinculado",
      mission_skills_none: "Ninguna competencia vinculada por el momento",
      mission_skills_add_placeholder: "+ Añadir una competencia…",
      mission_skills_info: 'Estas acciones se guardan de inmediato, sin usar el botón "Guardar" de la misión.',
      mission_category_added: ({ named }) => `Bloque ${named("name")} añadido a la misión`,
      mission_category_validated: ({ named }) => `Bloque ${named("name")} validado`,
      mission_category_refused: ({ named }) => `Sugerencia ${named("name")} rechazada`,
      mission_category_removed: ({ named }) => `Bloque ${named("name")} quitado de la misión`,
    },
    import: {
      title: "Fragmentación de la ficha de misión",
      intro: "La IA identifica y reformula las misiones de la ficha — usted elige cuáles publicar.",
      existing_sheet: "Ficha de misión",
      upload_pdf: "Subir un PDF",
      free_text: "O introducir el contenido directamente",
      free_text_placeholder: "Pegue o escriba el contenido de su ficha de misión…",
      or: "o",
      or_replace: "o cargar otra ficha",
      has_file_alert: "Ficha importada desde el expediente de inscripción",
      split_failed: "La fragmentación automática no ha funcionado. Por favor, vuelva a iniciar la fragmentación.",
      launch: "Iniciar la extracción",
      loading_title: "Fragmentación en curso...",
      loading_subtitle: "La IA analiza y reformula las misiones",
      missions_proposed: "misión/misiones propuesta(s)",
      validate_all: "Validar todo",
      results_actions: "Acciones sobre las misiones propuestas",
      validate: "Validar",
      edit: "Modificar",
      remove: "Eliminar",
      confirm_edit: "Confirmar la modificación",
      field_name: "Nombre de la misión",
      field_description: "Descripción de la misión",
      no_missions: "No se han propuesto misiones.",
      publish: ({ named }) => `Publicar ${named("count")} misión/misiones`,
      publish_success: ({ named }) => `${named("count")} misión/misiones publicada(s) con éxito`,
      removal_announcement: ({ named }) =>
        `Misión "${named("name")}" eliminada. ${named("count")} misión/misiones propuesta(s) restante(s).`,
    },
    banner: {
      title: "Se ha importado una ficha de misión desde el expediente de inscripción",
      subtitle: "Divida esta ficha en misiones para seguir el progreso del aprendiz a lo largo de la alternancia",
      import: "Proceder con la importación",
      import_tooltip: "Abrir el modal de fragmentación de la ficha de misión",
      later: "Más tarde",
      later_tooltip: "Ocultar este banner durante esta sesión",
    },
  },
};
